// extracted by mini-css-extract-plugin
export var hidden = "_w2-0";